export const SET_OFFER_RELATED = 'SET_OFFER_RELATED';
export const REMOVE_OFFER_RELATED = 'REMOVE_OFFER_RELATED';
export const PUSH_OFFER_RELATED = 'PUSH_OFFER_RELATED';